var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"education__card"},[_c('a',{attrs:{"href":_vm._f("stripHTML")(_vm.information.detail),"target":"_blank"}},[_c('p',[_vm._v(_vm._s(_vm.information.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }